import { GvpPlayer, GvpPlayerProps, GvpPlayerData, GvpPlayerOptions } from ".";
import React from "react";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";

export class GvpPlayerInterface
  extends ComponentInterfaceBaseClass
  implements GvpPlayerProps
{
  key: string;
  data: GvpPlayerData;
  options?: GvpPlayerOptions;
  additionalAnalyticsData?: any;
  radius?: boolean;

  static initWithSanity(key, feed) {
    const videoStyles = {
      height: feed?.videoHeight,
      width: feed?.videoWidth
    };
    const t = new GvpPlayerInterface();
    //console.log("initSanity after new", feed);
    t.key = key;
    t.data = {
        video: feed?.videoId,
    }
    t.options = {
        modal: feed?.modal,
        cinema: feed?.cinema,
        autoplay: feed?.autoplay,
        viewportPause: feed?.viewportPause,
        autoPlayLoop: feed?.autoPlayLoop,
        autoPlayPause: feed?.autoPlayPause,
        customTheme: feed?.customTheme,
        overlayTextDisplayAtEnd: feed?.overlayTextDisplayAtEnd,
        tier: feed?.tier,
        rating: feed?.rating,
        customCTAStyle: feed?.customCTAStyle,
        showTime: feed?.showTime,
        showTitle: feed?.showTitle,
        videoStyles: JSON.stringify(videoStyles),
        autoReduceSize: feed?.autoReduceSize,
        isScroll: feed?.isScroll,
        customCTAObject: feed?.customCTAObject,
        playerView: feed?.playerView,
        unconstrained: feed?.unconstrained,
    }
    t.additionalAnalyticsData = feed?.additionalAnalyticsData;
    t.radius = feed?.radius;
    return t;
  }

  toProps(): GvpPlayerProps {
    const props = {
      key: this.key,
      data: this.data,
      options: this.options,
      additionalAnalyticsData: this.additionalAnalyticsData,
      radius: this.radius,
    };
    return props;
  }

  toJsx(): JSX.Element {
    return React.createElement(GvpPlayer, {
      ...this.toProps(),
    });
  }

}
